import React, { useMemo } from 'react';
import { Box, Tooltip } from '@mui/material';
import { formatAudioDuration } from '@/components/util';
import { statusConfig } from './RecordingStatusSemaphore';

interface RecordingStatusBarProps {
  statusDistribution: Record<string, number>;
  totalDuration: number;
  height?: number | string;
}

export const RecordingStatusBar: React.FC<
  RecordingStatusBarProps
> = ({ statusDistribution, totalDuration, height = 16 }) => {
  // Sort statuses in a specific order
  const sortedStatuses = Object.entries(statusDistribution).sort(
    (a, b) => {
      // Define the order of statuses (transcribed first)
      const statusOrder = [
        'unknown',
        'failed',
        'draft',
        'splitted',
        'committed',
        'uploaded',
        'validated',
        'transcribed',
      ];

      return statusOrder.indexOf(a[0]) - statusOrder.indexOf(b[0]);
    },
  );

  // Calculate coverage - disregarding milliseconds by converting to seconds
  const totalDurationInSeconds = Math.floor(totalDuration / 1000);

  const totalRecordedDurationInSeconds = Object.values(
    statusDistribution,
  ).reduce(
    (sum: number, duration: any) =>
      sum + Math.floor(Number(duration) / 1000),
    0,
  );

  const coverage = useMemo(() => {
    console.log('totalDurationInSeconds', totalDurationInSeconds);
    console.log(
      'totalRecordedDurationInSeconds',
      totalRecordedDurationInSeconds,
    );

    const coverage =
      totalDurationInSeconds > 0
        ? (totalRecordedDurationInSeconds / totalDurationInSeconds) *
          100
        : 0;

    console.log('🕵️‍♂️🕵️‍♂️🕵️‍♂️ coverage', coverage);

    return coverage;
  }, [totalDurationInSeconds, totalRecordedDurationInSeconds]);

  return (
    <Box sx={{ width: '100%', display: 'flex', height }}>
      {sortedStatuses.map(([status, duration]) => {
        const config =
          (statusConfig as any)[status] || statusConfig.unknown;
        const durationInSeconds = Math.floor(Number(duration) / 1000);
        const percentage =
          totalDurationInSeconds > 0
            ? (durationInSeconds / totalDurationInSeconds) * 100
            : 0;

        return (
          <Tooltip
            key={status}
            title={`${config.label}: ${formatAudioDuration(
              Number(duration),
            )} (${percentage.toFixed(1)}%)`}
          >
            <Box
              sx={{
                width: `${percentage}%`,
                backgroundColor: config.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '0.7rem',
                fontWeight: 'bold',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              {percentage > 5 ? `${percentage.toFixed(0)}%` : ''}
            </Box>
          </Tooltip>
        );
      })}

      {coverage < 100 && (
        <Tooltip
          title={`Uncovered: ${formatAudioDuration(
            totalDuration -
              Object.values(statusDistribution).reduce(
                (sum, duration) => sum + Number(duration),
                0,
              ),
          )}`}
        >
          <Box
            sx={{
              width: `${100 - coverage}%`,
              backgroundColor: '#E0E0E0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#757575',
              fontSize: '0.7rem',
              fontWeight: 'bold',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
          >
            {100 - coverage > 5
              ? `${(100 - coverage).toFixed(0)}%`
              : ''}
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
